import { Component, OnInit, Input } from '@angular/core';
interface WaivedInterest {
  customerName: string;
  customerUniqueIdentifier: number;
  idX1: number;
  interestWavedOff: number;
  loanAmountTaken: number;
  loanProductCode: number;
  rateUsed: number;
  regionalName: string;
  stationName: string;
  townName: string;
}
@Component({
  selector: 'app-waived-interest',
  templateUrl: './waived-interest.component.html',
  styleUrls: ['./waived-interest.component.scss']
})
export class WaivedInterestComponent implements OnInit {

  constructor() { }
  @Input() itm: WaivedInterest;
  ngOnInit(): void {
  }

}
